<template>
  <div>
    The thrust attitude mode corresponds to the satellite's attitude during
    propulsion arcs. It can either be:
    <ul>
      <li>
        <b>Prograde</b>: the propulsion system axis is aligned with the inertial
        velocity vector. A rotation around this axis is performed to optimise
        the lighting of the solar array.
      </li>
      <br />
      <li>
        <b>Normal</b>: The propulsion system axis is aligned with the direction
        of the orbit's angular momentum vector (that is, perpendicular to the
        orbit plane). A rotation around the propulsion system axis is performed
        to optimise the lighting of the solar array.
      </li>
      <br />
      <li>
        <b>Radial</b>: The propulsion system axis is aligned with the vector
        from the planet's center to the satellite. A rotation around the
        propulsion system axis is performed to optimise the lighting of the
        solar array.
      </li>
      <br />
      <li>
        <b>Custom</b>: the propulsion system axis is aligned with a direction
        vector, in the TNW local orbital frame. A rotation around the propulsion
        system axis is performed to optimise the lighting on the solar array.
        Alternatively, a hypothetical maneuver can be simulated (only its first
        orbit), in which case the propulsion system axis will be adapted
        continuously according to the instantaneous optimal thrusting direction.
      </li>
      <br />
    </ul>
  </div>
</template>

<script>
export default {
  name: 'tooltipThrustAttitudeMode'
}
</script>
